import { Component, OnInit, ViewChild } from '@angular/core';
import { _HttpClient, ModalHelper, ModalHelperOptions } from '@delon/theme';
import { Router } from '@angular/router';
import {
  STChange,
  STColumn,
  STComponent,
  STData,
  STPage,
  STReq,
  STRequestOptions,
  STRes,
} from '@delon/abc';
import { format } from 'date-fns';
import { MessageService } from 'mmmo-mo-common-lib';
import { DialogService } from 'mmmo-mo-common-lib';
import { URLS } from '../../shared/constant/interface';
import { getEndDate, getStartDate } from '../../shared/utils/time';
import { isJsonString } from '../../shared/utils/common';

@Component({
  selector: 'app-voice',
  templateUrl: './voice.component.html',
  styles: [
    `
      .search-btns {
        display: flex;
        align-items: center;
      }
      .expand-box {
        margin-left: 10px;
        color: #49536e;
        font-size: 12px;
      }
      .expand-box:hover {
        color: #37ba9d;
      }

      ::ng-deep .ant-calendar-time-picker-btn {
        display: none !important;
      }
    `,
  ],
})
export class CommentVoiceComponent implements OnInit {
  constructor(
    private messageService: MessageService,
    private http: _HttpClient,
    private modal: ModalHelper,
    private router: Router,
    private dialogService: DialogService
  ) {}

  // 自定义组件名
  static NAME = 'icc-msg-comment';

  isOpenContentDetail = false;
  // 当前查看详情的模板
  currentTemplate: any = [];
  isOpenExport = false;
  detailItem = {
    isMo: true,
    msgType: null,
    content: '',
  };

  url = URLS.voiceMoRecord.url;
  expandForm = false;

  options: ModalHelperOptions = {
    /** 大小；例如：lg、600，默认：`lg` */
    size: 500,
  };
  @ViewChild('st', { static: false }) st: STComponent;
  columns: STColumn[] = [
    // { title: '渠道商', index: 'providerName' },
    {
      title: '接收渠道号',
      index: 'channelName',
      width: 200,
      className: 'text-center',
    },
    {
      title: '上行号码',
      index: 'terminalId',
      width: 150,
      className: 'text-center',
    },
    {
      title: '接收账号',
      index: 'receiveUser',
      width: 150,
      className: 'text-center',
    },
    {
      title: '上行时间',
      index: 'postTime',
      type: 'date',
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      width: 200,
      className: 'text-center',
    },
    {
      title: '上行时长',
      index: 'moDuration',
      width: 100,
      className: 'text-center',
    },
    {
      title: '操作',
      width: 100,
      className: 'text-center',
      buttons: [
        {
          text: '播放语音',
          click: (item, instance) => {
            const VoiceModalDetailComponent =
              this.messageService.getModalDetailComponent(
                this.messageService.getMsgTypeByName('voice', true)
              );
            if (VoiceModalDetailComponent && isJsonString(item.content)) {
              const obj = JSON.parse(item.content);
              this.modal
                .createStatic(VoiceModalDetailComponent, {
                  moAudioUrl: obj.content,
                  isMo: true,
                })
                .subscribe(() => {});
            }
          },
          iif: (item, btn, column) => {
            return item.voiceUrl;
          },
        },
      ],
    },
  ];
  req: STReq = {
    method: 'POST',
    allInBody: true,
    body: {
      params: {
        start: format(getStartDate(new Date(), 7), 'yyyy-MM-dd HH:mm:ss'),
        end: format(getEndDate(new Date(), 0), 'yyyy-MM-dd HH:mm:ss'),
      },
    },
    process: (requestOptions: STRequestOptions) => {
      return requestOptions;
    },
  };

  page: STPage = {
    zeroIndexed: true,
  };
  res: STRes = {};
  // 选中的数据
  selectedRows: STData[] = [];
  /*searchOptions*/
  searchOptions: any = {
    providerName: '',
    terminalId: '',
    channelName: '',
    dateRange: [getStartDate(new Date(), 7), getEndDate(new Date(), 0)],
  };

  // 等待导出的文件路径列表
  waitingExportFiles: any = [];
  // 存放时间，用于过期
  waitingExportFilesMap: { [key: string]: Date } = {};
  downloadPath = URLS.attachment.url + '?module=15&attach=2&path=';
  // 过期时间 10分钟
  expiredTime = 10 * 60 * 60 * 1000;

  _handleClose() {
    this.isOpenContentDetail = false;
  }

  stChange(e: STChange) {
    switch (e.type) {
      case 'checkbox':
        this.selectedRows = e.checkbox!;
        break;
      case 'filter':
        this.st.reload();
        break;
    }
  }

  ngOnInit() {
    this.detailItem = {
      isMo: true,
      msgType: this.messageService.getMsgTypeByName('voice', true),
      content: '',
    };
  }

  getTableList() {
    this.st.reset({
      params: {
        providerName: this.searchOptions.providerName,
        terminalId: this.searchOptions.terminalId,
        channelName: this.searchOptions.channelName,
        start:
          this.searchOptions.dateRange.length >= 1
            ? format(this.searchOptions.dateRange[0], 'yyyy-MM-dd HH:mm:ss')
            : null,
        end:
          this.searchOptions.dateRange.length >= 2
            ? format(this.searchOptions.dateRange[1], 'yyyy-MM-dd HH:mm:ss')
            : null,
      },
    });
  }

  resetTableList() {
    // 重置搜索条件
    this.searchOptions.providerName = '';
    this.searchOptions.terminalId = '';
    this.searchOptions.channelName = '';
    this.searchOptions.dateRange = [
      getStartDate(new Date(), 7),
      getEndDate(new Date(), 0),
    ];
    // 重新加载table数据
    this.getTableList();
  }

  goExport() {
    this.router.navigateByUrl('/system/import-export/export');
  }
  closeExport() {
    this.isOpenExport = false;
  }

  export() {
    // 判断前端表格是否有数据，如果没有，则直接返回“无数据可导出”
    if (!this.st._data || this.st._data.length === 0) {
      this.dialogService.notification.warning('导出', '无数据可导出');
      return;
    }
    this.http
      .post(URLS.voiceMoRecordExport.url, {
        params: {
          providerName: this.searchOptions.providerName,
          terminalId: this.searchOptions.terminalId,
          channelName: this.searchOptions.channelName,
          start:
            this.searchOptions.dateRange.length >= 1
              ? format(this.searchOptions.dateRange[0], 'yyyy-MM-dd HH:mm:ss')
              : null,
          end:
            this.searchOptions.dateRange.length >= 2
              ? format(this.searchOptions.dateRange[1], 'yyyy-MM-dd HH:mm:ss')
              : null,
        },
      })
      .subscribe((res) => {
        if (res.status === 0) {
          this.isOpenExport = true;
          this.waitingExportFiles.push(res.data);
          this.waitingExportFilesMap[res.data] = new Date();
        } else {
          this.dialogService.notification.error('导出', res.errorMsg);
        }
      });
  }

  ngOnDestroy() {}

  // 设置开始时间为00:00:00 结束时间为23:59:59
  onOkDate() {
    if (this.searchOptions.dateRange[0]) {
      // 设置开始时间为选择日期的 00:00:00
      this.searchOptions.dateRange[0] = new Date(
        new Date(
          new Date(this.searchOptions.dateRange[0]).toLocaleDateString()
        ).getTime()
      );
    }
    if (this.searchOptions.dateRange[1]) {
      // 设置开始时间为选择日期的 23:59:59
      this.searchOptions.dateRange[1] = new Date(
        new Date(
          new Date(this.searchOptions.dateRange[1]).toLocaleDateString()
        ).getTime() +
          24 * 60 * 60 * 1000 -
          1
      );
    }
  }
}
